if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach(mediaToSwitch => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      setActiveMedia(mediaId, prepend) {
        const mediaGalleries = document.querySelectorAll(`[data-container="media-gallery"]`);
        mediaGalleries.forEach(mediaGallery => {
          const activeMedia = mediaGallery.querySelector(`[data-media-id="${mediaId}"]`);
          mediaGallery.querySelectorAll('[data-media-id]').forEach(element => {
            element.classList.remove('is-active');
          });

          activeMedia.classList.add('is-active');

          mediaGallery.querySelectorAll('.thumbnail-list__item').forEach(thumbnail => {
            thumbnail.querySelector('button').removeAttribute('aria-current');
          });

          mediaGallery.querySelectorAll(`[data-target="${mediaId}"]`).forEach(activeThumbnail => {
            activeThumbnail.querySelector('button').setAttribute('aria-current', true);
          });
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach(element => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}
